export enum SweatMatchStatusesEnum {
	Seen =  0,
	Skipped = 1,
	WaveSent = 2,
	ChatOpenedOrRequested = 3,
	DontShowAnymore = 4,
}
